module.exports = __webpack_public_path__ + "img/login-bg.4745e88f.jpg";